module.exports = __webpack_public_path__ + "static/media/social7.2d6dab30.png";